export enum FormErrorMessageKey {
  NONE = 'NONE',
  EmptyOrNoDecimalTemperature = 'EmptyOrNoDecimalTemperature',
  Under20DegTemperature = 'Under20DegTemperature',
}
